/* global angular, Modernizr */

var ngModule = angular.module('trends');

ngModule.service('HoverFocus', function() {
    this.parentElement = [];
});

ngModule.directive('addToPptHover', ['HoverFocus', '$rootScope',
    function (HoverFocus, $rootScope) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                element.addClass('add-ppt-hover');
                var enterPptBuilderArea = function(e){
                    /* Needs to be recomputed everytime
                    (otherwise carousel with an outer add to ppt do no work by instance) */
                    e.stopPropagation();
                    var addToPptTarget = element.find('.add-to-pptbuilder').first();
                    $rootScope.$broadcast('resetAdd2pptHover');
                    HoverFocus.parentElement = element.parents('.add-ppt-hover');
                    element.addClass('add2ppt-hover');
                    addToPptTarget.css('opacity', 1);
                };
                var leavePptBuilderArea = function() {
                    var addToPptTarget = element.find('.add-to-pptbuilder').first();

                    // We want the button to appear and
                    // remain in place when highlighted by the tour
                    if (!addToPptTarget.data('ppt-button-lock')) {
                        element.removeClass('add2ppt-hover');
                        addToPptTarget.css('opacity', ''); 

                        if (HoverFocus.parentElement.length === 1) {
                            var tmp = HoverFocus.parentElement;
                            HoverFocus.parentElement = [];
                            tmp.trigger('mouseenter');
                        }
                    }
                };
                if (!Modernizr.touch) {
                    element.hover(
                        enterPptBuilderArea,
                        leavePptBuilderArea
                    );
                }
                else {
                    element.on('touchend', function(e) {
                        e.stopPropagation(); /* Prevent the outer click to be triggered when nested addToPptHover */
                        $rootScope.$broadcast('resetAdd2pptHover');
                        var addToPptTarget = element.find('.add-to-pptbuilder').first();
                        element.addClass('add2ppt-hover');
                        addToPptTarget.css('opacity', 1);
                    });
                }
                scope.$on('resetAdd2pptHover', function() {
                    HoverFocus.nestedFocusStack = [];
                    leavePptBuilderArea();
                });
            }
        };
}]);
